import React from "react";
import { toPercentStyle } from "./resultConfig";

export default function OverlayText({
                                        pos,
                                        children,
                                        className = "",
                                        fontSize,
                                        typography = {},
                                    }) {
    const {
        fontFamily,
        letterSpacing,
        fontWeight,
        textAlign,
        color,
        lineHeight,
        textShadow,
        offsetY,
    } = typography;

    const style = {
        ...toPercentStyle(pos),
        ...(fontSize ? { "--overlay-font-size": fontSize } : {}),
        ...(offsetY ? { "--overlay-offset-y": offsetY } : {}),
        ...(fontFamily ? { fontFamily } : {}),
        ...(letterSpacing ? { "--overlay-letter-spacing": letterSpacing } : {}),
        ...(fontWeight ? { "--overlay-font-weight": fontWeight } : {}),
        ...(textAlign ? { textAlign } : {}),
        ...(color ? { color } : {}),
        ...(lineHeight ? { "--overlay-line-height": lineHeight } : {}),
        ...(textShadow ? { textShadow } : {}),
    };

    return (
        <div className={`overlay ${className}`} style={style}>
            <span className="overlay-text-content">{children}</span>
        </div>
    );
}
